/**
 * Created by Karol Kluska on 13.06.18.
 */

angular
  .module('uib/template/datepicker/datepicker.html', [])
  .run(overrideDatepickerTemplate);

function overrideDatepickerTemplate($templateCache) {
  $templateCache.put('uib/template/datepicker/datepicker.html',
    '<div ng-switch="datepickerMode">' +
      '<div uib-daypicker ng-switch-when="day" tabindex="0" class="uib-daypicker"></div>' +
      '<div uib-monthpicker ng-switch-when="month" tabindex="0" class="uib-monthpicker"></div>' +
      '<div uib-yearpicker ng-switch-when="year" tabindex="0" class="uib-yearpicker"></div>' +
    '</div>'
  );
}
